module.exports = __webpack_public_path__ + "static/EWY_Bilaal Ashfak_CASE_STUDY-9d716380f94fe7f2e919a8fcf191cf58.mp4";